import React from "react";
import WheatIcon from "../../../assets/images/commodityIcons/Wheat.png";
import CornIcon from "../../../assets/images/commodityIcons/Corn.png";
import SoybeansIcon from "../../../assets/images/commodityIcons/Soybeans.png";
import CanolaIcon from "../../../assets/images/commodityIcons/Canola.png";
import styles from "../styles";

function Grading() {
  const headerStyle = {
    backgroundColor: styles.primaryColor,
  };

  return (
    <div className="w-full h-full mt-[100px] flex flex-col items-center px-4 md:px-8 lg:px-16 pb-12">
      <div className="max-w-5xl w-full">
        <h1 className="text-2xl md:text-3xl font-bold text-center mb-2">
          Collwest Grain Ltd. Grading Parameters and Discounts
        </h1>
        <p className="text-center text-sm md:text-base mb-8">
          All grading is according to Canadian Grain Commission Standards
        </p>
        <GrainSection headerStyle={headerStyle} />
        <CornSection headerStyle={headerStyle} />
        <SoybeansSection headerStyle={headerStyle} />
        <CanolaSection headerStyle={headerStyle} />
      </div>
    </div>
  );
}

// Component for the wheat section
const GrainSection = ({ headerStyle }) => {
  return (
    <section className="mb-12">
      <div className="flex items-center gap-2 mb-4">
        <img src={WheatIcon} alt="Wheat" className="w-14 h-14" />
        <h2 className="text-xl font-semibold">Wheat</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div className="bg-white shadow-sm rounded-md overflow-hidden">
          <div
            className="text-white py-2 px-4 grid grid-cols-2"
            style={headerStyle}
          >
            <span>Grade</span>
            <span>Change</span>
          </div>
          <div className="divide-y divide-gray-200">
            <div className="grid grid-cols-2 py-2 px-4 bg-gray-50">
              <span className="text-sm md:text-base">#2 Wheat</span>
              <span className="text-sm md:text-base">No Discount</span>
            </div>
            <div className="grid grid-cols-2 py-2 px-4">
              <span className="text-sm md:text-base">Grade 3</span>
              <span className="text-sm md:text-base">$10.00/Mt Discount</span>
            </div>
            <div className="grid grid-cols-2 py-2 px-4 bg-gray-50">
              <span className="text-sm md:text-base">Feed Grade</span>
              <span className="text-sm md:text-base text-left">
                Discount according to feed wheat prices
              </span>
            </div>
          </div>
        </div>

        <div className="bg-white shadow-sm rounded-md overflow-hidden">
          <div className="text-white py-2 px-4" style={headerStyle}>
            <div className="text-center mb-1">Wheat Parameters</div>
            <div className="text-xs text-center">
              Max moisture before shrink & drying - 14%
            </div>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full min-w-full">
              <thead>
                <tr>
                  <th
                    colSpan="3"
                    className="text-white py-2 px-1 text-center text-xs md:text-sm"
                    style={headerStyle}
                  >
                    Grade #2
                  </th>
                  <th
                    colSpan="3"
                    className="text-white py-2 px-1 text-center text-xs md:text-sm"
                    style={headerStyle}
                  >
                    Grade #3
                  </th>
                </tr>
                <tr
                  className="text-white text-xs md:text-sm"
                  style={headerStyle}
                >
                  <th className="py-1 px-1 text-center"></th>
                  <th className="py-1 px-1 text-center">Test wt.</th>
                  <th className="py-1 px-1 text-center">% Sprouts</th>
                  <th className="py-1 px-1 text-center"></th>
                  <th className="py-1 px-1 text-center">Test wt.</th>
                  <th className="py-1 px-1 text-center">% Sprouts</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                <tr className="bg-gray-50">
                  <td className="py-2 px-1 text-center text-xs md:text-sm">
                    SWW
                  </td>
                  <td className="py-2 px-1 text-center text-xs md:text-sm">
                    74kg/hl
                  </td>
                  <td className="py-2 px-1 text-center text-xs md:text-sm">
                    2.5%
                  </td>
                  <td className="py-2 px-1 text-center text-xs md:text-sm"></td>
                  <td className="py-2 px-1 text-center text-xs md:text-sm">
                    69 kg/hl
                  </td>
                  <td className="py-2 px-1 text-center text-xs md:text-sm">
                    8.0%
                  </td>
                </tr>
                <tr>
                  <td className="py-2 px-1 text-center text-xs md:text-sm">
                    SRW
                  </td>
                  <td className="py-2 px-1 text-center text-xs md:text-sm">
                    74kg/hl
                  </td>
                  <td className="py-2 px-1 text-center text-xs md:text-sm">
                    2.5%
                  </td>
                  <td className="py-2 px-1 text-center text-xs md:text-sm"></td>
                  <td className="py-2 px-1 text-center text-xs md:text-sm">
                    69 kg/hl
                  </td>
                  <td className="py-2 px-1 text-center text-xs md:text-sm">
                    8.0%
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="py-2 px-1 text-center text-xs md:text-sm">
                    HRW
                  </td>
                  <td className="py-2 px-1 text-center text-xs md:text-sm">
                    74kg/hl
                  </td>
                  <td className="py-2 px-1 text-center text-xs md:text-sm">
                    2.5%
                  </td>
                  <td className="py-2 px-1 text-center text-xs md:text-sm"></td>
                  <td className="py-2 px-1 text-center text-xs md:text-sm">
                    69 kg/hl
                  </td>
                  <td className="py-2 px-1 text-center text-xs md:text-sm">
                    8.0%
                  </td>
                </tr>
                <tr>
                  <td className="py-2 px-1 text-center text-xs md:text-sm">
                    HRS
                  </td>
                  <td className="py-2 px-1 text-center text-xs md:text-sm">
                    74kg/hl
                  </td>
                  <td className="py-2 px-1 text-center text-xs md:text-sm">
                    2.5%
                  </td>
                  <td className="py-2 px-1 text-center text-xs md:text-sm"></td>
                  <td className="py-2 px-1 text-center text-xs md:text-sm">
                    69 kg/hl
                  </td>
                  <td className="py-2 px-1 text-center text-xs md:text-sm">
                    8.0%
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <h3 className="font-semibold mb-2">Protein Premiums</h3>
          <div className="text-xs md:text-sm mb-4">
            <div>HRW</div>
            <div>Deductions may apply under 10%</div>
            <div className="mt-2">HRS</div>
            <div>Premium included in price, must be over 12.5%</div>
          </div>

          <div className="bg-white shadow-sm rounded-md overflow-hidden">
            <div
              className="text-white py-2 px-4 grid grid-cols-2"
              style={headerStyle}
            >
              <span>Protein</span>
              <span>Discount</span>
            </div>
            <div className="divide-y divide-gray-200">
              <div className="grid grid-cols-2 py-2 px-4 bg-gray-50">
                <span className="text-sm md:text-base">12.0% to 12.4%</span>
                <span className="text-sm md:text-base">$8.00/Mt Discount</span>
              </div>
              <div className="grid grid-cols-2 py-2 px-4">
                <span className="text-sm md:text-base">under 12.0%</span>
                <span className="text-sm md:text-base">$18.00/Mt Discount</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Corn section component
const CornSection = ({ headerStyle }) => {
  return (
    <section className="mb-12">
      <div className="flex items-center gap-2 mb-4">
        <img src={CornIcon} alt="Corn" className="w-14 h-14" />
        <h2 className="text-xl font-semibold">Corn</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-white shadow-sm rounded-md overflow-hidden">
          <div
            className="text-white py-2 px-4 grid grid-cols-2"
            style={headerStyle}
          >
            <span>Grade</span>
            <span>Discount</span>
          </div>
          <div className="divide-y divide-gray-200">
            <div className="grid grid-cols-2 py-2 px-4 bg-gray-50">
              <span className="text-sm md:text-base">#2 C.E. Corn</span>
              <span className="text-sm md:text-base">No Discount</span>
            </div>
            <div className="grid grid-cols-2 py-2 px-4">
              <span className="text-sm md:text-base">Grade 3</span>
              <span className="text-sm md:text-base">$8.00/Mt Discount</span>
            </div>
            <div className="grid grid-cols-2 py-2 px-4 bg-gray-50">
              <span className="text-sm md:text-base">Grade 4</span>
              <span className="text-sm md:text-base">$12.00/Mt Discount</span>
            </div>
            <div className="grid grid-cols-2 py-2 px-4">
              <span className="text-sm md:text-base">Grade 5</span>
              <span className="text-sm md:text-base">$10.00/Mt Discount</span>
            </div>
            <div className="grid grid-cols-2 py-2 px-4 bg-gray-50">
              <span className="text-sm md:text-base">Sample Grade</span>
              <span className="text-sm md:text-base">-</span>
            </div>
          </div>
        </div>

        <div className="bg-white shadow-sm rounded-md overflow-hidden">
          <div className="text-white py-2 px-4" style={headerStyle}>
            <div className="text-center mb-1">Corn Parameters</div>
            <div className="text-xs text-center">
              Max Moisture before shrink & drying 15.5%
            </div>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full min-w-full">
              <thead>
                <tr>
                  <th
                    colSpan="3"
                    className="text-white py-2 px-2 text-center text-xs md:text-sm"
                    style={headerStyle}
                  >
                    Corn Grade Parameters
                  </th>
                </tr>
                <tr
                  className="text-white text-xs md:text-sm"
                  style={headerStyle}
                >
                  <th className="py-2 px-2 text-center">Grade</th>
                  <th className="py-2 px-2 text-center">Test wt.</th>
                  <th className="py-2 px-2 text-center">% Sprouts</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                <tr>
                  <td className="py-2 px-2 text-center text-xs md:text-sm">
                    Grade 1
                  </td>
                  <td className="py-2 px-2 text-center text-xs md:text-sm">
                    68kg/hl
                  </td>
                  <td className="py-2 px-2 text-center text-xs md:text-sm">
                    2.0%
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="py-2 px-2 text-center text-xs md:text-sm">
                    Grade 2
                  </td>
                  <td className="py-2 px-2 text-center text-xs md:text-sm">
                    66kg/hl
                  </td>
                  <td className="py-2 px-2 text-center text-xs md:text-sm">
                    3.0%
                  </td>
                </tr>
                <tr>
                  <td className="py-2 px-2 text-center text-xs md:text-sm">
                    Grade 3
                  </td>
                  <td className="py-2 px-2 text-center text-xs md:text-sm">
                    64kg/hl
                  </td>
                  <td className="py-2 px-2 text-center text-xs md:text-sm">
                    5.0%
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="py-2 px-2 text-center text-xs md:text-sm">
                    Grade 4
                  </td>
                  <td className="py-2 px-2 text-center text-xs md:text-sm">
                    62kg/hl
                  </td>
                  <td className="py-2 px-2 text-center text-xs md:text-sm">
                    7.0%
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

const SoybeansSection = ({ headerStyle }) => {
  return (
    <section className="mb-12">
      <div className="flex items-center gap-2 mb-4">
        <img src={SoybeansIcon} alt="Soybeans" className="w-14 h-14" />
        <h2 className="text-xl font-semibold">Soybeans</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div className="bg-white shadow-sm rounded-md overflow-hidden">
          <div
            className="text-white py-2 px-4 grid grid-cols-2"
            style={headerStyle}
          >
            <span>Grade</span>
            <span>Discount</span>
          </div>
          <div className="divide-y divide-gray-200">
            <div className="grid grid-cols-2 py-2 px-4 bg-gray-50">
              <span className="text-sm md:text-base">#2 Yellow Soybeans</span>
              <span className="text-sm md:text-base">No Discount</span>
            </div>
            <div className="grid grid-cols-2 py-2 px-4">
              <span className="text-sm md:text-base">Grade 3</span>
              <span className="text-sm md:text-base">$2.00/Mt Discount</span>
            </div>
            <div className="grid grid-cols-2 py-2 px-4 bg-gray-50">
              <span className="text-sm md:text-base">Grade 4</span>
              <span className="text-sm md:text-base">$5.00/Mt Discount</span>
            </div>
            <div className="grid grid-cols-2 py-2 px-4">
              <span className="text-sm md:text-base">Grade 5</span>
              <span className="text-sm md:text-base">$10.00/Mt Discount</span>
            </div>
            <div className="grid grid-cols-2 py-2 px-4 bg-gray-50">
              <span className="text-sm md:text-base">Sample Grade</span>
              <span className="text-sm md:text-base text-right md:text-left">
                Negotiable (depends on reason for downgrade)
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white shadow-sm rounded-md overflow-hidden mb-4">
        <div className="text-white py-2 px-4" style={headerStyle}>
          <h3 className="font-medium">Bean Parameters</h3>
        </div>
        <div className="p-4">
          <ul className="list-disc pl-5 space-y-1 text-xs md:text-sm">
            <li>Max Moisture before shrink applied - 13%</li>
            <li>Max Heated - 0.5%</li>
            <li>Max FM - 2% other grains (ie. corn, wheat, etc)</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

const CanolaSection = ({ headerStyle }) => {
  return (
    <section className="mb-12">
      <div className="flex items-center gap-2 mb-4">
        <img src={CanolaIcon} alt="Canola" className="w-14 h-14" />
        <h2 className="text-xl font-semibold">Canola Parameters</h2>
      </div>

      <p className="mb-4 text-sm">No discount for #1 canola seed.</p>

      <div className="bg-white shadow-sm rounded-md overflow-hidden">
        <div className="text-white py-2 px-4 text-center" style={headerStyle}>
          <span>Percentage Allowed</span>
        </div>
        <div className="divide-y divide-gray-200">
          <div className="grid grid-cols-2 py-2 px-4 bg-gray-50">
            <span className="font-semibold text-sm md:text-base">
              Parameter
            </span>
            <span className="font-semibold text-sm md:text-base">Value</span>
          </div>
          <div className="grid grid-cols-2 py-2 px-4">
            <span className="text-sm md:text-base">Max Moisture</span>
            <span className="text-sm md:text-base">No Discount</span>
          </div>
          <div className="grid grid-cols-2 py-2 px-4">
            <span className="text-sm md:text-base">Max Heated</span>
            <span className="text-sm md:text-base">$10.00/Mt Discount</span>
          </div>
          <div className="grid grid-cols-2 py-2 px-4 bg-gray-50">
            <span className="text-sm md:text-base">Max Green Seeds</span>
            <span className="text-sm md:text-base">
              Discount according to feed wheat prices
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Grading;
